module.exports = __webpack_public_path__ + "01_bob_brown.0b6e9304.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_bob_brown.png
// module id = Xecn
// module chunks = 0